var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 99,
    viewBox: "0 0 156 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.329 0.133911H83.7539V7.70899H91.329V0.133911Z",
    fill: "#FFC84F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.329 7.71338H83.7539V15.2885H91.329V7.71338Z",
    fill: "#AE7911"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.329 15.2885H83.7539V22.8636H91.329V15.2885Z",
    fill: "#6E4E0B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.329 22.8639H83.7539V30.439H91.329V22.8639Z",
    fill: "#96690E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91.329 30.4432H83.7539V38.1567H91.329V30.4432Z",
    fill: "#96690E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.329 38.1571H83.7539V45.7322H91.329V38.1571Z",
    fill: "#96690E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.329 45.7323H83.7539V53.3074H91.329V45.7323Z",
    fill: "#FFC84F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.329 53.3069H83.7539V60.882H91.329V53.3069Z",
    fill: "#96690E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.329 60.8868H83.7539V68.462H91.329V60.8868Z",
    fill: "#96690E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.329 68.4623H83.7539V76.1758H91.329V68.4623Z",
    fill: "#96690E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M91.329 76.1755H83.7539V83.7506H91.329V76.1755Z",
    fill: "#FFC84F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M91.329 83.7509H83.7539V91.3259H91.329V83.7509Z",
    fill: "#96690E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9012 7.71338H91.3262V15.2885H98.9012V7.71338Z",
    fill: "#FFE3A5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9012 15.2885H91.3262V22.8636H98.9012V15.2885Z",
    fill: "#FFC84F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9012 22.8639H91.3262V30.439H98.9012V22.8639Z",
    fill: "#6E4E0B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9012 30.4432H91.3262V38.1567H98.9012V30.4432Z",
    fill: "#96690E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9012 38.1571H91.3262V45.7322H98.9012V38.1571Z",
    fill: "#96690E"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9012 45.7323H91.3262V53.3074H98.9012V45.7323Z",
    fill: "#FFE3A5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9012 53.3069H91.3262V60.882H98.9012V53.3069Z",
    fill: "#6E4E0B"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9012 60.8868H91.3262V68.462H98.9012V60.8868Z",
    fill: "#96690E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9012 68.4623H91.3262V76.1758H98.9012V68.4623Z",
    fill: "#6E4E0B"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9012 76.1755H91.3262V83.7506H98.9012V76.1755Z",
    fill: "#FFE3A5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9012 83.7509H91.3262V91.3259H98.9012V83.7509Z",
    fill: "#96690E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M106.489 22.8639H98.9141V30.439H106.489V22.8639Z",
    fill: "#FFC84F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M106.489 30.4432H98.9141V38.1567H106.489V30.4432Z",
    fill: "#6E4E0B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M106.489 38.1571H98.9141V45.7322H106.489V38.1571Z",
    fill: "#6E4E0B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M106.489 45.7323H98.9141V53.3074H106.489V45.7323Z",
    fill: "#6E4E0B"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M106.489 53.3069H98.9141V60.882H106.489V53.3069Z",
    fill: "#FFE3A5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M106.489 60.8868H98.9141V68.462H106.489V60.8868Z",
    fill: "#96690E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M106.489 68.4623H98.9141V76.1758H106.489V68.4623Z",
    fill: "#FFE3A5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M106.489 76.1755H98.9141V83.7506H106.489V76.1755Z",
    fill: "#96690E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M106.489 83.7509H98.9141V91.3259H106.489V83.7509Z",
    fill: "#96690E"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M114.057 38.1571H106.482V45.7322H114.057V38.1571Z",
    fill: "#FFC84F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M114.057 45.7323H106.482V53.3074H114.057V45.7323Z",
    fill: "#6E4E0B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M114.057 53.3069H106.482V60.882H114.057V53.3069Z",
    fill: "#6E4E0B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M114.057 60.8868H106.482V68.462H114.057V60.8868Z",
    fill: "#96690E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M114.057 68.4623H106.482V76.1758H114.057V68.4623Z",
    fill: "#96690E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M114.057 76.1755H106.482V83.7506H114.057V76.1755Z",
    fill: "#96690E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M114.057 83.7509H106.482V91.3259H114.057V83.7509Z",
    fill: "#96690E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M121.776 45.7323H114.062V53.3074H121.776V45.7323Z",
    fill: "#FFC84F"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M121.776 53.3069H114.062V60.882H121.776V53.3069Z",
    fill: "#96690E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M121.776 60.8868H114.062V68.462H121.776V60.8868Z",
    fill: "#6E4E0B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M121.776 68.4623H114.062V76.1758H121.776V68.4623Z",
    fill: "#6E4E0B"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M121.776 76.1755H114.062V83.7506H121.776V76.1755Z",
    fill: "#96690E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M121.776 83.7509H114.062V91.3259H121.776V83.7509Z",
    fill: "#96690E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M129.347 60.8868H121.771V68.462H129.347V60.8868Z",
    fill: "#FFC84F"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M129.347 68.4623H121.771V76.1758H129.347V68.4623Z",
    fill: "#96690E"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M129.347 76.1755H121.771V83.7506H129.347V76.1755Z",
    fill: "#6E4E0B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M129.347 83.7509H121.771V91.3259H129.347V83.7509Z",
    fill: "#6E4E0B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M136.925 76.1755H129.35V83.7506H136.925V76.1755Z",
    fill: "#FFC84F"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M136.925 83.7509H129.35V91.3259H136.925V83.7509Z",
    fill: "#6E4E0B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M144.509 83.7509H136.934V91.3259H144.509V83.7509Z",
    fill: "#FFC84F"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7487 7.71338H76.0352V15.2885H83.7487V7.71338Z",
    fill: "#FFC84F"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7487 15.2885H76.0352V22.8636H83.7487V15.2885Z",
    fill: "#FFC84F"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7487 22.8639H76.0352V30.439H83.7487V22.8639Z",
    fill: "#96690E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7487 30.4432H76.0352V38.1567H83.7487V30.4432Z",
    fill: "#96690E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7487 38.1571H76.0352V45.7322H83.7487V38.1571Z",
    fill: "#96690E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7487 45.7323H76.0352V53.3074H83.7487V45.7323Z",
    fill: "#FFC84F"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7487 53.3069H76.0352V60.882H83.7487V53.3069Z",
    fill: "#96690E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7487 60.8868H76.0352V68.462H83.7487V60.8868Z",
    fill: "#96690E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7487 68.4623H76.0352V76.1758H83.7487V68.4623Z",
    fill: "#96690E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7487 76.1755H76.0352V83.7506H83.7487V76.1755Z",
    fill: "#FFC84F"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7487 83.7509H76.0352V91.3259H83.7487V83.7509Z",
    fill: "#96690E"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M76.038 22.8639H68.4629V30.439H76.038V22.8639Z",
    fill: "#FFC84F"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M76.038 30.4432H68.4629V38.1567H76.038V30.4432Z",
    fill: "#96690E"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M76.038 38.1571H68.4629V45.7322H76.038V38.1571Z",
    fill: "#96690E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M76.038 45.7323H68.4629V53.3074H76.038V45.7323Z",
    fill: "#6E4E0B"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M76.038 53.3069H68.4629V60.882H76.038V53.3069Z",
    fill: "#FFC84F"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M76.038 60.8868H68.4629V68.462H76.038V60.8868Z",
    fill: "#FFC84F"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M76.038 68.4623H68.4629V76.1758H76.038V68.4623Z",
    fill: "#FFC84F"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M76.038 76.1755H68.4629V83.7506H76.038V76.1755Z",
    fill: "#6E4E0B"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M76.038 83.7509H68.4629V91.3259H76.038V83.7509Z",
    fill: "#96690E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4618 38.1571H60.8867V45.7322H68.4618V38.1571Z",
    fill: "#FFC84F"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4618 45.7323H60.8867V53.3074H68.4618V45.7323Z",
    fill: "#96690E"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4618 53.3069H60.8867V60.882H68.4618V53.3069Z",
    fill: "#6E4E0B"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4618 60.8868H60.8867V68.462H68.4618V60.8868Z",
    fill: "#6E4E0B"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4618 68.4623H60.8867V76.1758H68.4618V68.4623Z",
    fill: "#6E4E0B"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4618 76.1755H60.8867V83.7506H68.4618V76.1755Z",
    fill: "#96690E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4618 83.7509H60.8867V91.3259H68.4618V83.7509Z",
    fill: "#96690E"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8817 45.7323H53.3066V53.3074H60.8817V45.7323Z",
    fill: "#FFC84F"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8817 53.3069H53.3066V60.882H60.8817V53.3069Z",
    fill: "#96690E"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8817 60.8868H53.3066V68.462H60.8817V60.8868Z",
    fill: "#96690E"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8817 68.4623H53.3066V76.1758H60.8817V68.4623Z",
    fill: "#96690E"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8817 76.1755H53.3066V83.7506H60.8817V76.1755Z",
    fill: "#96690E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8817 83.7509H53.3066V91.3259H60.8817V83.7509Z",
    fill: "#96690E"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3131 60.8868H45.5996V68.462H53.3131V60.8868Z",
    fill: "#FFC84F"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3131 68.4623H45.5996V76.1758H53.3131V68.4623Z",
    fill: "#96690E"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3131 76.1755H45.5996V83.7506H53.3131V76.1755Z",
    fill: "#96690E"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3131 83.7509H45.5996V91.3259H53.3131V83.7509Z",
    fill: "#96690E"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5946 76.1755H38.0195V83.7506H45.5946V76.1755Z",
    fill: "#FFC84F"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5946 83.7509H38.0195V91.3259H45.5946V83.7509Z",
    fill: "#96690E"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0224 83.7509H30.4473V91.3259H38.0224V83.7509Z",
    fill: "#FFC84F"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M114.057 30.4432H106.482V38.1567H114.057V30.4432Z",
    fill: "#FFE3A5"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4618 30.4432H60.8867V38.1567H68.4618V30.4432Z",
    fill: "#FFC84F"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M91.329 91.3307H83.7539V98.9058H91.329V91.3307Z",
    fill: "#FFC84F"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9012 91.3307H91.3262V98.9058H98.9012V91.3307Z",
    fill: "#FFC84F"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M106.489 91.3307H98.9141V98.9058H106.489V91.3307Z",
    fill: "#FFC84F"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M114.057 91.3307H106.482V98.9058H114.057V91.3307Z",
    fill: "#FFC84F"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M121.776 91.3307H114.062V98.9058H121.776V91.3307Z",
    fill: "#FFC84F"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M129.347 91.3307H121.771V98.9058H129.347V91.3307Z",
    fill: "#FFC84F"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M136.925 91.3307H129.35V98.9058H136.925V91.3307Z",
    fill: "#FFC84F"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M144.509 91.3307H136.934V98.9058H144.509V91.3307Z",
    fill: "#FFC84F"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7487 91.3307H76.0352V98.9058H83.7487V91.3307Z",
    fill: "#FFC84F"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M76.038 91.3307H68.4629V98.9058H76.038V91.3307Z",
    fill: "#FFC84F"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4618 91.3307H60.8867V98.9058H68.4618V91.3307Z",
    fill: "#FFC84F"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8817 91.3307H53.3066V98.9058H60.8817V91.3307Z",
    fill: "#FFC84F"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3131 91.3307H45.5996V98.9058H53.3131V91.3307Z",
    fill: "#FFC84F"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5946 91.3307H38.0195V98.9058H45.5946V91.3307Z",
    fill: "#FFC84F"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0224 91.3307H30.4473V98.9058H38.0224V91.3307Z",
    fill: "#FFC84F"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M152.215 91.3307H144.502V98.9058H152.215V91.3307Z",
    fill: "#FFC84F"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4344 91.3307H22.8594V98.9058H30.4344V91.3307Z",
    fill: "#FFC84F"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5946 68.4623H38.0195V76.1758H45.5946V68.4623Z",
    fill: "#FFC84F"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M136.925 68.4623H129.35V76.1758H136.925V68.4623Z",
    fill: "#FFE3A5"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3131 53.3069H45.5996V60.882H53.3131V53.3069Z",
    fill: "#FFC84F"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M129.347 53.3069H121.771V60.882H129.347V53.3069Z",
    fill: "#FFE3A5"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M91.329 7.71338H83.7539V15.2885H91.329V7.71338Z",
    fill: "#6E4E0B"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7487 0.133911H76.0352V7.70899H83.7487V0.133911Z",
    fill: "#825E16"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M76.038 7.71338H68.4629V15.2885H76.038V7.71338Z",
    fill: "#825E16"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M76.038 15.2885H68.4629V22.8636H76.038V15.2885Z",
    fill: "#825E16"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4618 22.8639H60.8867V30.439H68.4618V22.8639Z",
    fill: "#825E16"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8817 38.1571H53.3066V45.7322H60.8817V38.1571Z",
    fill: "#825E16"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3131 45.7323H45.5996V53.3074H53.3131V45.7323Z",
    fill: "#825E16"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5946 60.8868H38.0195V68.462H45.5946V60.8868Z",
    fill: "#825E16"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0224 76.1755H30.4473V83.7506H38.0224V76.1755Z",
    fill: "#825E16"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4344 83.7509H22.8594V91.3259H30.4344V83.7509Z",
    fill: "#825E16"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8817 30.4432H53.3066V38.1567H60.8817V30.4432Z",
    fill: "#825E16"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8622 91.3307H15.2871V98.9058H22.8622V91.3307Z",
    fill: "#825E16"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0224 68.4623H30.4473V76.1758H38.0224V68.4623Z",
    fill: "#825E16"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5946 53.3069H38.0195V60.882H45.5946V53.3069Z",
    fill: "#825E16"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M136.925 30.4432H129.35V38.1567H136.925V30.4432Z",
    fill: "#96690E"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M144.509 22.8639H136.934V30.439H144.509V22.8639Z",
    fill: "#FFC84F"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M152.215 15.2885H144.502V22.8636H152.215V15.2885Z",
    fill: "#FFE3A5"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0224 38.1571H30.4473V45.7322H38.0224V38.1571Z",
    fill: "#96690E"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4344 30.4432H22.8594V38.1567H30.4344V30.4432Z",
    fill: "#FFC84F"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8622 22.8639H15.2871V30.439H22.8622V22.8639Z",
    fill: "#FFC84F"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2936 15.2885H7.58008V22.8636H15.2936V15.2885Z",
    fill: "#FFE3A5"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8622 60.8868H15.2871V68.462H22.8622V60.8868Z",
    fill: "#96690E"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2936 60.8868H7.58008V68.462H15.2936V60.8868Z",
    fill: "#FFC84F"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57507 60.8868H0V68.462H7.57507V60.8868Z",
    fill: "#FFE3A5"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M148.292 60.8868H140.717V68.462H148.292V60.8868Z",
    fill: "#96690E"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M156.001 60.8868H148.287V68.462H156.001V60.8868Z",
    fill: "#FFC84F"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M91.329 0H83.7539V7.71349H91.329V0Z",
    fill: "#FFE3A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4cf3c9711f273c5ec9b9c4984d8d330a.svg";
export { ForwardRef as ReactComponent };